<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="save" :loading="btnLoading">保存</el-button>
      <!-- <el-button  @click="close">关闭</el-button> -->
    </div>
    <div>
      <el-form :model="lhc" label-position="left" label-width="100px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="说明"  prop="lhcname" >
              <el-input v-model.trim="lhc.lhcname" :maxlength="40" show-word-limit :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <p>----------------------------------------收入方---------------------------------------------------</p>
        <el-row>
          <el-col :span="11">
            <el-form-item label="收发列号" prop="lhcrscol" >
              <el-select v-model="lhc.lhcrscol" placeholder="请选择" :disabled="disable">
                <el-option v-for="item in rsColOpts"  :key="item.index" :label="item.value" :value="item.index">
                </el-option>
              </el-select>
              <el-select v-model="lhc.lhcrsflg" placeholder="请选择" :disabled="disable">
                <el-option v-for="item in flgOpts" :key="item.index" :label="item.value"  :value="item.index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="结存列号" prop="lhcscol">
              <el-select v-model="lhc.lhcscol" placeholder="请选择" :disabled="disable">
                <el-option v-for="item in sColOpts" :key="item.index" :label="item.value" :value="item.index">
                </el-option>
              </el-select>
              <el-select v-model="lhc.lhcsflg" placeholder="请选择" :disabled="disable">
                <el-option v-for="item in flgOpts" :key="item.index" :label="item.value" :value="item.index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="分布列号" prop="lhclcscol">
              <el-select v-model="lhc.lhclcscol" placeholder="请选择" :disabled="disable">
                <el-option v-for="item in lcsColOpts" :key="item.index" :label="item.value" :value="item.index">
                </el-option>
              </el-select>
              <el-select v-model="lhc.lhclcsflg" placeholder="请选择" :disabled="disable">
                <el-option v-for="item in flgOpts" :key="item.index"  :label="item.value"  :value="item.index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <p>----------------------------------------发出方----------------------------------------------------</p>
        <el-row>
          <el-col :span="11">
            <el-form-item label="收发列号" prop="lhcrscol1">
              <el-select v-model="lhc.lhcrscol1" clearable placeholder="请选择" :disabled="disable">
                <el-option  v-for="item in rsColOpts" :key="item.index" :label="item.value" :value="item.index">
                </el-option>
              </el-select>
              <el-select v-model="lhc.lhcrsflg1" clearable placeholder="请选择" :disabled="disable">
                <el-option v-for="item in flgOpts" :key="item.index" :label="item.value" :value="item.index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="结存列号" prop="lhcscol1">
              <el-select v-model="lhc.lhcscol1" clearable placeholder="请选择" :disabled="disable">
                <el-option v-for="item in sColOpts" :key="item.index" :label="item.value" :value="item.index">
                </el-option>
              </el-select>
              <el-select v-model="lhc.lhcsflg1" clearable placeholder="请选择" :disabled="disable">
                <el-option  v-for="item in flgOpts" :key="item.index" :label="item.value" :value="item.index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="分布列号" prop="lhclcscol1" >
              <el-select v-model="lhc.lhclcscol1" clearable placeholder="请选择" :disabled="disable">
                <el-option v-for="item in lcsColOpts" :key="item.index" :label="item.value" :value="item.index">
                </el-option>
              </el-select>
              <el-select v-model="lhc.lhclcsflg1" clearable placeholder="请选择" :disabled="disable">
                <el-option v-for="item in flgOpts" :key="item.index" :label="item.value" :value="item.index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  export default {
    name: "lhcform",
    data () {
      return {
        lhc: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        rsColOpts: [
          {
            index:0,
            value:'无'
          },{
            index:1,
            value:'采购收入'
          },{
            index:2,
            value:'委外收入'
          },{
            index:3,
            value:'制造收入'
          },{
            index:4,
            value:'其他收入'
          },{
            index:5,
            value:'调拨收入'
          },{
            index:6,
            value:'盘点'
          },{
            index:7,
            value:'销售发出'
          },{
            index:8,
            value:'制造发出'
          },{
            index:9,
            value:'委外发出'
          },{
            index:10,
            value:'其他发出'
          },{
            index:11,
            value:'报废'
          },{
            index:12,
            value:'调拨发出'
          },
        ],//收发列号
        flgOpts:[{index:1,value:'增加'},{index:-1,value:'减少'},{index:0,value:'无影响'}],//对收发,结存,分布,列影响
        sColOpts:[{index:0,value:'无'},{index:1,value:'单位库存'},{index:2,value:'非单位库存'}],//结存列号
        lcsColOpts: [
          {
            index:0,value:'无'
          },
          {
            index:1,value:'收入'
          },
          {
            index:2,value:'发出'
          },
          {
            index:3,value:'盘盈'
          },
          {
            index:4,value:'报废'
          },
        ],//公布列号
      }
    },
    created () {
    },
    watch: {
    },
    filters: {
    },
    methods: {
      async save () {
        let model = {
          insertRecords: [],
          updateRecords: [],
          removeRecords: []
        }
        if (this.lhc.lhcid === 0) {
          model.insertRecords = [this.lhc]
        } else {
          model.updateRecords = [this.lhc]
        }
        await this.addOrEdit(model)
      },
      async addOrEdit (model) {
        if (model.insertRecords.length===0 && model.updateRecords.length === 0 && model.removeRecords.length ===0) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let data = await request({
          url: '/kfgl/lhc/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'lhcIndex'})
      }
    }
  }
</script>

<style scoped>
  .input2 {
    margin-left: 20px;
  }
</style>
